import { DesignModuleNodeConfig, ObjectClass } from '@app/types';
import en from '../../languages/en.json';

export const objectConfigLabels = new Map<ObjectClass | 'default', Map<string, string>>([
  [
    'default',
    new Map<keyof DesignModuleNodeConfig, string>([
      ...(Object.entries(en.property) as [keyof DesignModuleNodeConfig, string][])
    ])
  ]
  // Left here as reference
  // [
  //   ObjectClass.richText,
  //   // Using generic 'DesignModuleNodeConfig' instead of 'RichTextConfig'
  //   // until the later is well defined
  //   new Map<keyof (DesignModuleNodeConfig & RichTextConfigObject), string>([
  //     ['type', 'Type'],
  //     ['uri', 'Form URL'],
  //     ['mapping', 'Mapping'],
  //     ['buttons', 'Buttons']
  //   ])
  // ]
]);
